<template lang="html">
  <section>
    <h2 id="about">About Us</h2>

    <div class="container">
      <img class="move-right" src="location.png" alt="">
      <p>The District School Board of Niagara’s Outdoor Adventure Campus is
      situated on the boundary of Short Hills Provincial Park in Fonthill and
      provides exceptional opportunities for outdoor and environmental education
      for our students.</p>

      <p>Our Outdoor Adventure Guides have Bachelor’s/Master’s Degrees in
        Science, Kinesiology, Environmental Studies, Outdoor Recreation and
        Outdoor and Experiential Education. Our full day programs are for
        students from K-12 and focus on inquiry and exploration based learning,
        encouraging all students to Play, Explore and Discover in nature.
        Highlights include our Team and Leadership Building Low Ropes Course,
        Geocaching, Outdoor Survival Skills, GPS and Snow Shoeing.</p>
    </div>
    <div class="container right-side">
      <div class="column left">
        <img src="secondary.png" alt="">
      </div>
      <div class="right column">
        <blockquote>If we want children to flourish, to become truly empowered,
        then let us allow them to love the earth before we ask them to save
        it.</blockquote>

        <p>We provide students with the opportunity to dive into their imagination
          and explore their surroundings through unstructured, risky, free play.
          We encourage students to let their adventurous spirit lead them and
          encourage them to:</p>
        <ul>
          <li>think creatively</li>
          <li>rely on their senses</li>
          <li>asses risk</li>
          <li>test their boundaries</li>
          <li>use their outside voice</li>
          <li>resolve conflict</li>
          <li>improvise solutions</li>
          <li>learn through play</li>
          <li>wonder why</li>
          <li>get messy</li>
          <li>go barefoot</li>
          <li>develop their strength</li>
          <li>&hellip;and So Much More!</li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
require('../assets/location.png')
require('../assets/secondary.png')
export default {
}
</script>

<style lang="less" scoped>
@import '../css/variables';

section {
  padding: 2em 1em;
  @media(min-width: @mobile) {
    padding: 2em 4em;
  }

  font-size: 1.1em;
  background-image: url(../assets/topography-light.svg);
  background-size: 25%;

  .container:after {
    content: ' ';
    display: block;
    position: relative;
    clear: both;
  }

  blockquote {
    @media(min-width: @mobile) {
      &:before, &:after {
        content: open-quote;
        font-size: 1.5em;
        line-height: 0;
        opacity: 0.6;
        font-family: sans-serif;
      }
      &:after {
        content: close-quote;
      }
      padding: 1em 1.8em 1em 2em;
    }
    padding: 2em 0;
    position: relative;
    quotes: "“" "”" "‘" "’";
    color: @adventure-primary;
    font-size: 2em;
  }

  @media(min-width: @mobile) {
    .container {
      @media(min-width: 1200px) {
        p, li {
          font-size: 1.5vmax;
        }
      }
      .column {
        float: left;
        &.left {
          max-width: 33%;
          img {
            max-width: 100%;
          }
        }
        &.right {
          max-width: 66%;
          padding-left: 7%;
        }
      }
    }
  }

  ul {
    padding-left: 1.5em;
    @media(min-width: @mobile) {
      li {
        float:left;
        width:50%;
      }
    }
  }

  img {
    max-width: 100%;
    &.move-right {
      margin-top: -5em;
      @media(min-width: @mobile) {
        float: right;
        max-width: 50%;
        padding-left: 3em;
        max-width: 45%;
      }
    }
  }
  h2 {
    margin-bottom: 1em;
    color: @adventure-primary;
    font-size: 2em;
  }
  p { margin-bottom: 1em;}
}
</style>



// WEBPACK FOOTER //
// Content.vue?243c1a3c